import React, { useCallback } from 'react';

import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { ErrorScreen } from '@atlassian/generative-ai-modal/screens/Error';

import { ErrorMessage } from '../../../utils/error-handling';
import { Container } from '../Container';
import type { Action } from '../hooks/useUIState';
import type { SessionUIComponentProps } from '../SessionUIComponent';

export function ErrorSessionScreen({
	api,
	appearance,
	dispatch,
}: Omit<SessionUIComponentProps, 'providerFactory'> & {
	dispatch: React.Dispatch<Action>;
}): React.JSX.Element {
	const errorScreenRef = React.useRef<HTMLDivElement | null>(null);
	const { errorInfo, isInDocumentStreamingEnabled, nextSessionId } =
		useSharedPluginStateWithSelector(api, ['aiExperience'], ({ aiExperienceState }) => {
			return {
				errorInfo: aiExperienceState?.aiSessionPluginState?.errorInfo || {},
				isInDocumentStreamingEnabled:
					aiExperienceState?.aiDecorationExperiencePluginState.isInDocumentStreamingEnabled,
				nextSessionId: aiExperienceState?.aiDecorationExperiencePluginState.nextSessionId,
			};
		});

	const onCancel = useCallback(() => {
		api?.aiExperience.actions.endSession(nextSessionId || '', { type: 'error' });
		api?.aiExperience.actions.endAIExperience();
		dispatch({ type: 'terminate' });
	}, [api, dispatch, nextSessionId]);

	return (
		<Container ref={errorScreenRef} appearance={appearance}>
			<ErrorScreen
				text={ErrorMessage(errorInfo)}
				onCancel={onCancel}
				onRetry={() => {}}
				showRetryButton={false}
				appearance={appearance}
				isAIFC={isInDocumentStreamingEnabled}
			/>
		</Container>
	);
}
